import { NotConsentedRedirect, useIsOnboardingRoute, useTenants } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";

/**
 * Gate: redirects with <Navigate>, so it renders inside the page layout, in `ModuleGates`, never above it.
 * See .claude/rules/providers-and-gates.md.
 */
export function ConsentGate({ children }: PropsWithChildren) {
    const isConsented = useTenants().tenants?.primaryTenant?.isConsented === true;
    const isOnboardingRoute = useIsOnboardingRoute();

    if (!isConsented && !isOnboardingRoute) {
        return <NotConsentedRedirect />;
    }

    return children;
}
